import { BackgroundBanner, GuideDetail, PieceBanner, Refund } from "@/domains/components";
import {
    useGetDMaxCommon,
    type GuideDmaxInfoResponse,
    type MainInfoDmaxResponse,
    type RefundDmaxInfoResponse,
} from "@/shared/server";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";

export const Guide = () => {
    const { data: main } = useGetDMaxCommon<MainInfoDmaxResponse>({ section: "main" });
    const { data: guide } = useGetDMaxCommon<GuideDmaxInfoResponse>({ section: "guide" });
    const { data: refund } = useGetDMaxCommon<RefundDmaxInfoResponse>({ section: "refund" });

    return main && guide && refund ? (
        <Box w="100%">
            <PieceBanner
                imgUrl={main.imgList[0].img_URL}
                title={{
                    main: "Notice",
                    sub: "종합 예약안내",
                }}
            />
            <GuideDetail guide={guide} />
            <Refund refunds={refund} />
            <BackgroundBanner img_URL={main.imgList[1]?.img_URL} />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
